module.exports = __webpack_public_path__ + "static/media/TIME-off.021d9cfa.svg";